export default __webpack_public_path__ + "static/media/Stage2_clueicon_incorrect.3580ab86.svg";